import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";

function TreatTraw({ item }: any) {
  const [check, setcheck] = useState(false);
  const { ID } = useParams();
  useEffect(() => {
    setcheck(!item?.action);
  }, [item]);

  const onActionChange = (e: any) => {
    setcheck(!check);
    baseUrl
      .post(
        "treatment/addAction",
        {
          action: e.target.checked,
        },
        {
          headers: {
            treatmentid: ID,
            diagnoseid: item?._id,
          },
        }
      )
      .then((response) => {
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <tr className="hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
      <td className="px-4 py-3 text-sm font-medium text-slate-800 dark:text-slate-200">{item.diagnose}</td>
      <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item.toothNo}</td>
      <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item.surface}</td>
      <td className="px-4 py-3 text-sm text-slate-500 dark:text-slate-400 max-w-[150px] truncate">{item.note}</td>
      <td className="px-4 py-3">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
          item.priority === "high" ? "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400" :
          item.priority === "medium" ? "bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300" :
          "bg-slate-100 dark:bg-slate-600 text-slate-600 dark:text-slate-300"
        }`}>
          {item.priority}
        </span>
      </td>
      <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item.priority}</td>
      <td className="px-4 py-3 text-sm text-slate-600 dark:text-slate-400">{item.priority}</td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <span className={`text-xs font-medium ${check ? "text-indigo-600 dark:text-indigo-400" : "text-slate-400 dark:text-slate-500"}`}>No</span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={!check}
              onChange={onActionChange}
              className="sr-only peer"
            />
            <div className="w-9 h-5 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary"></div>
          </label>
          <span className={`text-xs font-medium ${!check ? "text-indigo-600 dark:text-indigo-400" : "text-slate-400 dark:text-slate-500"}`}>Yes</span>
        </div>
      </td>
    </tr>
  );
}

export default TreatTraw;
